import React from 'react'
import { SESSION_INTERFACE_IDS } from '../../domain'
import { FLOW_TYPES } from '../../providerIds'
import {
  createPublicLocalParticipantIdentity,
  createPublicPeerParticipantHint,
  readLocalParticipantIdentity,
  readSessionInterfaceId,
} from '../../session'
import SharedRtcVideoSurface from './SharedRtcVideoSurface'

export default function PublicLiveRtcVideoSurface({
  bookedEventInfo = null,
  sessionRoutingDecision,
  agoraRtcProps,
  agoraRtmProps,
  handleLeaveRoom,
  onUserJoin,
  onUserLeave,
  isFullHeight,
  onCameraClose,
  onCameraOpen,
  onAudioClose,
  onAudioOpen,
  callContainerStyles = {},
  agoraKitStyleProps = {},
  playAudioOnUserJoin = true,
  playAudioOnUserLeave = true,
  onUsernameMapUpdate,
  providerFallback = null,
}) {
  const localParticipantIdentity = React.useMemo(
    () =>
      readLocalParticipantIdentity(
        bookedEventInfo,
        createPublicLocalParticipantIdentity(bookedEventInfo),
      ),
    [bookedEventInfo],
  )
  const sessionInterfaceId = React.useMemo(
    () => readSessionInterfaceId(bookedEventInfo, FLOW_TYPES.publicLiveSession),
    [bookedEventInfo],
  )
  const peerParticipantHint = React.useMemo(
    () => createPublicPeerParticipantHint(bookedEventInfo),
    [bookedEventInfo],
  )

  return (
    <SharedRtcVideoSurface
      sessionRoutingDecision={sessionRoutingDecision}
      agoraRtcProps={agoraRtcProps}
      agoraRtmProps={agoraRtmProps}
      handleLeaveRoom={handleLeaveRoom}
      localParticipantIdentity={localParticipantIdentity}
      peerParticipantHint={peerParticipantHint}
      sessionInterfaceId={sessionInterfaceId || SESSION_INTERFACE_IDS.publicLive}
      onUserJoin={onUserJoin}
      onUserLeave={onUserLeave}
      isFullHeight={isFullHeight}
      onCameraClose={onCameraClose}
      onCameraOpen={onCameraOpen}
      onAudioClose={onAudioClose}
      onAudioOpen={onAudioOpen}
      callContainerStyles={callContainerStyles}
      agoraKitStyleProps={agoraKitStyleProps}
      playAudioOnUserJoin={playAudioOnUserJoin}
      playAudioOnUserLeave={playAudioOnUserLeave}
      onUsernameMapUpdate={onUsernameMapUpdate}
      providerFallback={providerFallback}
    />
  )
}

PublicLiveRtcVideoSurface.displayName = 'PublicLiveRtcVideoSurface'
